// define variable for travel time and locations default list
var insuranceLocationList;

$(function () {
  if (window.insuranceDays && window.insuranceDays.length) {
    appendTravelTimeList(window.insuranceDays);
  }

  if (window.insuranceLocation && window.insuranceLocation.length) {
    insuranceLocationList = window.insuranceLocation;
  } else {
    $.get("/insurance/getcountries/", function (data, status) {
      if (data.model && data.model.length) {
        insuranceLocationList = data.model;
      }
    });
  }

  $.get("/insurance/getdurationsofstay/?all=true", function (data, status) {
    if (data.model && data.model.length) {
      appendTravelTimeList(data.model);
    }
  });

  // toggle travel time list
  $(".js-toggle-insurance-time").click(function () {
    $(this).closest(".js-insurance-time").toggleClass("is-open");
    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }
  });

  // close travel time list
  $("body").on("click", function (event) {
    if (!$(event.target).closest(".js-insurance-time").length) {
      if ($(".js-insurance-time").hasClass("is-open")) {
        $(".js-insurance-time").removeClass("is-open");

        $("html").removeClass("no-scroll");
      }
    }
  });

  // change travel time value
  $("body").delegate(".js-insurance-time-item", "click", function () {
    $(".js-insurance-time-value").html($(this).html());
    $(".js-insurance-time-value").attr(
      "data-value",
      $(this).attr("data-value")
    );
    $(".js-insurance-time").removeClass("is-open");
  });

  // toggle person list
  $(".js-toggle-person-list").click(function () {
    $(".js-toggle-person").toggleClass("is-open");
    if (window.innerWidth < 993) {
      $("html").toggleClass("no-scroll");
    }
  });

  // close person list
  $("body").on("click", function (event) {
    if (!$(event.target).closest(".js-toggle-person").length) {
      if ($(".js-toggle-person").hasClass("is-open")) {
        $(".js-toggle-person").removeClass("is-open");

        $("html").removeClass("no-scroll");
      }
    }
  });

  // change insurance person count and create input for person birth date
  $(".js-person-item").click(function () {
    $("html").removeClass("no-scroll");

    var personCount = Number($(this).attr("data-value"));
    $(".js-person-value").html($(this).html());
    $(".js-person-value").attr("data-value", personCount);
    $(".js-toggle-person").removeClass("is-open");

    var datepickerItemLength = $(".js-inc-datepicker-item").length;

    if (personCount !== datepickerItemLength) {
      if (personCount > datepickerItemLength) {
        for (var i = datepickerItemLength + 1; i <= personCount; i++) {
          $(".js-inc-datepicker").append(
            "\
        <div class='insurance-booking__input insurance-booking__input--calendar js-inc-datepicker-item js-insurance-booking-input'>\
            <div class='insurance-booking__calendar js-inc-datepicker-calendar-new'>\
                <label class='insurance-booking__input-label'>تاریخ تولد مسافر " +
            i +
            " :</label>\
                <input type='text' placeholder='انتخاب تاریخ تولد' data-hj-whitelist readonly class='js-pick-date pickDate'>\
                <input type='hidden' />\
            </div>\
        </div>"
          );
        }

        initDatepicker();
      } else {
        for (var i = datepickerItemLength - 1; i >= personCount; i--) {
          $(".js-inc-datepicker-item")[i].remove();
        }
      }
    }
  });

  $(".js-insurance-booking .js-inc-datepicker-calendar").pickDate({
    dateFormat: "yy/mm/dd",
    dateFormatEn: "yy M dd",
    changeMonthAllow: true,
    changeYearAllow: true,
    showButtonPanel: true,
    isDependenceDates: false,
    showCurrentAtPos: 0,
    numberOfMonths: 1,
    yearRange: "c-100:+00",
    minDate: "1300/01/01",
    maxDate: new Date(),
    customClass: "lightTheme insurance",
    showAllMonthsinList: false,
    langType: "fa",
    blurInmobile: true,
    dayNamesShortFa: [
      "1شنبه",
      "2شنبه",
      "3شنبه",
      "4شنبه",
      "5شنبه",
      "جمعه",
      "شنبه",
    ],
    dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
    enterDateTitle: "تاریخ تولد مسافر",
    enterDateTitleEn: "Passenger date of birth",
    fillHidden: {
      enable: true,
      outPut: "en", //en | Dependent_On_SelectedDate | fa
      customformatInhidden: "YYYY-MM-DD",
    },
  });

  $(".js-search-insurance").click(function () {
    var baseUrl = "/fa/Insurance/result/?";
    var valid = true;

    $(".js-insurance-booking").find(".js-error-message").remove();
    $(".js-insurance-booking-input").removeClass("error");

    if ($(".js-insurance-location").data("code")) {
      baseUrl += "CountryCode=" + $(".js-insurance-location").data("code");
    } else {
      $(".js-insurance-location")
        .closest(".js-insurance-booking-input")
        .addClass("error");
      valid = false;
    }

    if ($(".js-insurance-time-value").attr("data-value")) {
      baseUrl +=
        "&DurationOfStay=" + $(".js-insurance-time-value").data("value");
    } else {
      $(".js-insurance-time-value")
        .closest(".js-insurance-booking-input")
        .addClass("error");
      valid = false;
    }

    $(".js-insurance-booking .pickDate").each(function (index, value) {
      if ($(this).val() !== "") {
        baseUrl += "&BirthDate[" + index + "]=" + $(this).next().val();
      } else {
        $(this).closest(".js-insurance-booking-input").addClass("error");
        valid = false;
      }
    });

    if (!valid) {
      $(".js-insurance-booking").append(
        "<span class='form-validation js-error-message'>لطفا تمام فیلدها را کامل نمایید</span>"
      );

      return false;
    } else {
      window.location.assign(baseUrl);
    }
  });

  // init autoComplete
  $(".js-insurance-location")
    .autocomplete({
      minLength: 0,
      delay: 400,
      source: function (request, response) {
        if (request.term === "") {
          var items =
            insuranceLocationList && insuranceLocationList.length
              ? insuranceLocationList
              : [];

          response(items);
        } else {
          var url = getResult($(".js-insurance-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },
      appendTo: $(".js-insurance-location").next(),
      search: function () {
        $(this).closest(".js-insurance-booking-input").addClass("is-open");

        if (window.innerWidth < 993) {
          $("html").addClass("no-scroll");
        }
      },
      select: function (event, ui) {
        $(this).attr("data-code", ui.item.code);
        $(this).attr("data-value", ui.item.title);
        $(this).val();
        $(this).attr("placeholder", ui.item.title);
      },
      open: function () {
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
      },
      close: function (e, ui) {
        $(this).closest(".js-insurance-booking-input").removeClass("is-open");
        $("html").removeClass("no-scroll");
      },
    })
    .bind("focus", function () {
      $(this).val("");
      $(this).autocomplete("search");
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
      return $("<li>").append(item.title).appendTo(ul);
    };

  // close location
  $(".js-insurance-booking").delegate(
    ".js-close-location-list",
    "click",
    function () {
      $(".js-insurance-location").autocomplete("close");
      $(this).closest(".js-insurance-booking-input").removeClass("is-open");
      $("html").removeClass("no-scroll");
    }
  );

  // show datepicker or autocomplete list when click on parent box
  $(document).delegate(".js-insurance-booking-input", "click", function (e) {
    if ($(this).find(".js-insurance-location").length) {
      if (
        !e.target.closest(".js-insurance-location") &&
        !e.target.closest(".js-autocomplete-list") &&
        !e.target.closest(".js-close-location-list")
      ) {
        $(this).find(".js-insurance-location").trigger("focus");
      }
    }

    if (
      $(this).find(".js-pick-date").length &&
      !e.target.closest(".js-pick-date")
    ) {
      $(this).find(".js-pick-date.hasDatepicker").datepicker("show");
    }
  });

  $(document).delegate(".js-insurance-booking-input", "focus", function () {
    if ($(window).width() > 992) {
      $(this)
        .closest(".insurance-booking__input")
        .addClass("is-open");
    }
  });

  $(document).delegate(".js-insurance-booking-input", "blur", function () {
    if ($(window).width() > 992) {
      $(this)
        .closest(".insurance-booking__input")
        .removeClass("is-open");
    }
  });
});

// init datePicker
function initDatepicker() {
  $(".js-insurance-booking .js-inc-datepicker-calendar-new").pickDate({
    dateFormat: "yy/mm/dd",
    dateFormatEn: "yy M dd",
    changeMonthAllow: true,
    changeYearAllow: true,
    showButtonPanel: true,
    isDependenceDates: false,
    showCurrentAtPos: 0,
    numberOfMonths: 1,
    yearRange: "c-100:+00",
    minDate: "1300/01/01",
    maxDate: new Date(),
    customClass: "lightTheme insurance",
    showAllMonthsinList: false,
    langType: "fa",
    blurInmobile: true,
    dayNamesShortFa: [
      "1شنبه",
      "2شنبه",
      "3شنبه",
      "4شنبه",
      "5شنبه",
      "جمعه",
      "شنبه",
    ],
    dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
    enterDateTitle: "تاریخ تولد مسافر",
    enterDateTitleEn: "Passenger date of birth",
    fillHidden: {
      enable: true,
      outPut: "en", //en | Dependent_On_SelectedDate | fa
      customformatInhidden: "YYYY-MM-DD",
    }
  });
}

// update auto complete after type
function getResult(input) {
  var dataUrl = "/insurance/getCountries/?Keyword=";

  if (input.val()) {
    dataUrl += input.val();
  }
  return dataUrl;
}

// append insurance travel time list item
function appendTravelTimeList(items) {
  $(".js-insurance-time-list").empty();

  if (items && items.length) {
    items.forEach(function (item) {
      $(".js-insurance-time-list").append(
        "<li class='js-insurance-time-item' data-value='" +
        item.value +
        "'>" +
        item.title +
        "</li>"
      );
    });
  }
}
